export const images = {
  heroBackground: '/img/hero-bg.jpg',
  profileImage: '/img/my-profile-img.jpg',
  me: '/img/me.jpg',
}; 